export default __webpack_public_path__ + "static/media/global.a8376513.svg";